import { Switch } from "@mui/material";
import { SettingRow } from "@src/appV2/redesign/components/SettingRow";
import { type ReactNode } from "react";

interface SettingToggleProps {
  title: string;
  subtitle?: ReactNode;
  checked: boolean;
  disabled?: boolean;
  loading?: boolean;
  onChange: (checked: boolean) => void;
}

export function SettingToggle({
  title,
  subtitle,
  checked,
  disabled = false,
  loading = false,
  onChange,
}: SettingToggleProps) {
  const isDisabled = disabled || loading;

  return (
    <SettingRow
      title={title}
      subtitle={subtitle}
      disabled={isDisabled}
      action={
        <Switch
          checked={checked}
          disabled={isDisabled}
          inputProps={{ "aria-label": title }}
          onChange={(event) => {
            onChange(event.target.checked);
          }}
        />
      }
    />
  );
}
